const $ = window.jQuery

import appUtils from './app_utils'

const getAttributeObject = function(str='') {
  // jquery .data() requires a data-name='{"name": "value"}' pattern, not good for minification
  const dataString = str.replace(/'/g, '"')
  let obj = {}
  try {
    obj = JSON.parse(dataString)
  } catch (e) {
    console.log(e)
  } finally {
    return obj
  }
}

const carouselSlideChangeStart = function(e, carInstance) {
    let $actionTarget = carInstance.$el.find('[data-slide-action-target]')
    if ($actionTarget.length) {
      $actionTarget.hide()
    }
}
const carouselSlideChangeEnd = function(e, carInstance) {
    let $slideElement = carInstance.$el.find('.swiper-slide-active')
    let $actionTarget = carInstance.$el.find('[data-slide-action-target]')
    if ($slideElement.length && $actionTarget.length) {
      if($slideElement.attr('data-slide-action')) {
        let params = Object.assign({ icon: 'play' }, getAttributeObject($slideElement.attr('data-slide-action'))) //$slideElement.data('slide-action')
        $actionTarget.html('<span class="swiper-action icon icon-' + params.icon + '"></span>')
        $actionTarget.attr('data-' + params.action, params.src)
        $actionTarget.show()
      } else {
        $actionTarget.hide()
      }
    }
}

const modalIframeClickHandler = function(e){
  let iframeSrc = $(this).attr('data-modal-iframe')
  if (iframeSrc && typeof(appUtils.openIframeModal) === 'function') {
    appUtils.openIframeModal(iframeSrc)
  }
}

const appInit = function() {
  appUtils.$window.on('carousel:slideChangeStart', carouselSlideChangeStart)
  appUtils.$window.on('carousel:slideChangeEnd', carouselSlideChangeEnd)

  $(document).on('click', '[data-modal-iframe]', modalIframeClickHandler)
}

const appDestroy = function() {
  appUtils.$window.off('carousel:slideChangeStart', carouselSlideChangeStart)
  appUtils.$window.off('carousel:slideChangeEnd', carouselSlideChangeEnd)

  $(document).off('click', '[data-modal-iframe]', modalIframeClickHandler)
}

export default {appInit, appDestroy}
